/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface BusinessSectorField
 */
export interface BusinessSectorField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof BusinessSectorField
     */
    value: string;
}

/**
 * Check if a given object implements the BusinessSectorField interface.
 */
export function instanceOfBusinessSectorField(value: object): value is BusinessSectorField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function BusinessSectorFieldFromJSON(json: any): BusinessSectorField {
    return BusinessSectorFieldFromJSONTyped(json, false);
}

export function BusinessSectorFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSectorField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function BusinessSectorFieldToJSON(value?: BusinessSectorField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

